export default {
  title: 'Carrier Account Management',
  menuGroup: 'Freight Management',
  filter: {
    keyword: 'Keyword',
    keywordPlaceholder: 'Search account name or carrier',
    status: 'Account Status',
    carrier: 'Carrier/Platform'
  },
  ui: {
    filterConfigName: 'Carrier Account Filter Config',
    filterConfigRemark: 'Default filter config for carrier account management'
  },
  columns: {
    accountName: 'Account Name',
    companyName: 'Company',
    carrierName: 'Carrier/Platform',
    loginAccount: 'Login Account',
    status: 'Status',
    enabled: 'Enabled',
    lastVerified: 'Last Verified'
  },
  actions: {
    create: 'Add Account',
    edit: 'Edit',
    test: 'Test',
    delete: 'Delete',
    batchTest: 'Batch Test',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    viewDetail: 'View Detail',
    testConnection: 'Test Connection',
    close: 'Close'
  },
  form: {
    createTitle: 'Add Account',
    editTitle: 'Edit Account',
    accountName: 'Account Name',
    accountNamePlaceholder: 'Enter account name, e.g. MSC Main Account',
    company: 'Company',
    companyPlaceholder: 'Select company',
    carrier: 'Carrier/Platform',
    carrierPlaceholder: 'Select carrier/platform',
    loginAccount: 'Login Account',
    loginAccountPlaceholder: 'Enter carrier login account',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    passwordEditPlaceholder: 'Enter new password (required)',
    passwordEditTip: 'Password must be re-entered when editing',
    remark: 'Remark',
    remarkPlaceholder: 'Internal remark',
    enabled: 'Enabled'
  },
  detail: {
    title: 'Account Detail',
    company: 'Company',
    carrier: 'Carrier/Platform',
    loginAccount: 'Login Account',
    password: 'Password',
    status: 'Status',
    enabled: 'Enabled',
    lastVerified: 'Last Verified',
    createdBy: 'Created By',
    createdAt: 'Created At',
    remark: 'Remark',
    tabVerification: 'Verification Records',
    viewSensitiveTitle: 'View Sensitive Info Requires Confirmation',
    viewSensitiveContent: 'After confirmation, the plaintext password will be shown and auto-masked again in 10 seconds. This action will be logged.',
    viewSensitiveFailed: 'Failed to reveal password'
  },
  testDialog: {
    title: 'Connectivity Test',
    testing: 'Testing...',
    success: 'Connected',
    fail: 'Connection Failed',
    summary: 'Completed: {success} succeeded, {fail} failed'
  },
  verification: {
    verifyTime: 'Verify Time',
    verifyMethod: 'Verify Method',
    result: 'Result',
    responseTime: 'Response Time',
    errorMessage: 'Error Message',
    verifyBy: 'Operator',
    filterResult: 'Result',
    empty: 'No verification records yet'
  },
  confirm: {
    delete: 'Delete this account? This cannot be undone.',
    disable: 'Disabled accounts will not be used for rate acquisition. Continue?',
    disableTitle: 'Confirm Disable',
    disableOk: 'Disable',
    batchDisable: 'Disable {count} selected accounts?',
    batchDisableTitle: 'Batch Disable'
  },
  message: {
    loadFailed: 'Failed to load accounts, please retry',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed, please retry',
    deleteInUse: 'Delete failed, account may be in use',
    enableSuccess: 'Enabled',
    disableSuccess: 'Disabled',
    operationFailed: 'Operation failed, please retry',
    saveSuccess: 'Account saved successfully',
    saveFailed: 'Save failed, please retry',
    verifyFailed: 'Invalid account or password, please verify again',
    testSuccess: 'Connection test succeeded ({time}ms)',
    testFailed: 'Connection test failed: {message}',
    testRequestFailed: 'Test request failed, please retry',
    testDisabledTip: 'Account is disabled, please enable it before testing',
    batchEnableSuccess: 'Enabled {count} accounts',
    batchDisableSuccess: 'Disabled {count} accounts',
    batchEnableFailed: 'Batch enable failed, please retry',
    batchDisableFailed: 'Batch disable failed, please retry',
    noPermission: 'No access permission',
    selectedCount: '{count} selected',
    carrierOptionsEmpty: 'No carriers available. Please ensure MDM service is running',
    carrierOptionsLoadFailed: 'Failed to load carrier options, please retry later'
  },
  empty: {
    list: 'No carrier accounts yet. Click Add Account to start.',
    search: 'No matching accounts found'
  },
  validation: {
    accountNameRequired: 'Please enter account name',
    accountNameMaxLength: 'Account name cannot exceed 100 characters',
    companyRequired: 'Please select company',
    carrierRequired: 'Please select carrier/platform',
    loginAccountRequired: 'Please enter login account',
    passwordRequired: 'Please enter password'
  },
  enums: {
    status: {
      normal: 'Normal',
      verifyFailed: 'Verify Failed',
      disabled: 'Disabled'
    },
    verifyResult: {
      success: 'Success',
      fail: 'Failed'
    },
    verifyMethod: {
      saveCheck: 'Save Check',
      connectivityTest: 'Connectivity Test',
      downstreamExecute: 'Downstream Execute'
    }
  },
  fixedCarriers: {
    CMA: 'CMA CGM',
    MSC: 'Mediterranean Shipping',
    OOCL: 'Orient Overseas',
    ONE: 'Ocean Network Express',
    HPL: 'Hapag-Lloyd',
    MSK: 'Maersk',
    HMM: 'Hyundai Merchant Marine',
    ZIM: 'ZIM Integrated Shipping',
    EMC: 'Evergreen Marine',
    COSCO: 'COSCO Shipping'
  },
  backendError: {
    carrierRequired: 'Carrier is required',
    carrierCodeNotFound: 'Unable to find carrier by code. Please check the configuration',
    connectivityTestFailed: 'Connectivity test failed',
    verifyServiceUnavailable: 'Account verification service unavailable. Please check price acquisition service configuration',
    accountNameRequired: 'Account name cannot be empty',
    companyRequired: 'Company cannot be empty',
    carrierPlatformRequired: 'Carrier/platform cannot be empty',
    loginRequired: 'Login account cannot be empty',
    passwordRequired: 'Login password cannot be empty',
    enabledRequired: 'Enabled status cannot be empty',
    accountIdRequired: 'Account ID cannot be empty',
    accountIdListRequired: 'Account ID list cannot be empty'
  }
}
